<template>
    <div class="row">
        <div class="header-spacer"></div>
        <div class="subnav-spacer"></div>
        <div class="d-flex col-12 sub-nav">
            <h3 class="fw-b fs-32 ff-os-b mb-0">{{ $t(`${$options.name}.title`) }}</h3>
            <el-button cls="ml-auto btn btn-outline-primary d-flex justify-content-center" @click="csvExport(selectedForExport)" :disabled="loading_export || selectedForExport.length === 0" :loading="loading_export" :success="success_export" :success-label="$t(`general.export_success`)" :loading-label="$t(`general.export_loading`)" :default-label="$t(`general.export_submit`)" />
        </div>

        <vue-good-table class="col-12" :columns="columns" :search-options="{ enabled : true }" :rows="containers" @on-selected-rows-change="selectionChanged" :select-options="{ enabled: true, disableSelectInfo: true }" styleClass="vgt-table light-table">
            <template slot="table-row" slot-scope="slotProps">
                <span v-if="slotProps.column.type === 'boolean'">
                    <i v-if="!!slotProps.formattedRow[slotProps.column.field]" class="fal fa-check text-success"></i>
                    <i v-else class="fal fa-times text-danger"></i>
                </span>
                <template v-else>
                    {{ slotProps.formattedRow[slotProps.column.field] }}
                </template>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import HasTableExport from './has-table-export';

export default {
    name: 'views.admin.containers',

    mixins: [HasTableExport],

    components: {
        VueGoodTable
    },

    data() {
        return {
            export_name: 'Appvalvas-containers-export',
            columns: [
                { width: '50px', label: 'id', field: 'id', sortable: false },
                { width: '100px', label: this.$t(`${this.$options.name}.container_title`), field: 'title' },
                { width: '100px', label: this.$t(`${this.$options.name}.subtitle`), field: 'subtitle' },
                { width: '120px', label: this.$t(`${this.$options.name}.containers_count`), field: 'containers_count', type: 'number' },
                { width: '100px', label: this.$t(`${this.$options.name}.objects_count`), field: 'objects_count', type: 'number' },
                { width: '120px', label: this.$t(`${this.$options.name}.has_floor_plan`), field: 'has_floor_plan', type: 'boolean' },
                { width: '150px', label: this.$t(`${this.$options.name}.created_at`), field: 'created_at', type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'PP' },
            ],
            selectedContainers: [],
        }
    },

    methods: {
        selectionChanged(changes) {
            this.selectedContainers = changes.selectedRows.map(u => { return { id: u.id } })
            this.exportableChanged(changes)
        },
    },

    computed: {
        containers() {
            return this.$store.getters['admin/containers']
        },
    }
}
</script>
